"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var Box_1 = require("../Box");
var Button_1 = require("../Button");
var Keyboard_1 = require("../Keyboard");
var Text_1 = require("../Text");
var TextInput_1 = require("../TextInput");
var SearchIcon = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  color: red;\n"], ["\n  color: red;\n"])));
var Searcher = /** @class */ (function (_super) {
    tslib_1.__extends(Searcher, _super);
    function Searcher() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = React.createRef();
        return _this;
    }
    Searcher.prototype.componentDidMount = function () {
        /* eslint-disable-next-line react/prop-types */
        var _a = this.props, filtering = _a.filtering, property = _a.property;
        if (this.inputRef.current && filtering === property) {
            this.inputRef.current.focus();
        }
    };
    Searcher.prototype.render = function () {
        var _a = this.props, filtering = _a.filtering, filters = _a.filters, onFilter = _a.onFilter, onFiltering = _a.onFiltering, property = _a.property;
        if (filtering === property) {
            return (React.createElement(Keyboard_1.Keyboard, { onEsc: function () { return onFiltering(undefined); } },
                React.createElement(Box_1.Box, { flex: true, pad: { horizontal: 'xsmall' } },
                    React.createElement(TextInput_1.TextInput, { ref: this.inputRef, value: filters[property], onChange: function (event) { return onFilter(property, event.target.value); }, onBlur: function () { return onFiltering(undefined); } }))));
        }
        return (React.createElement(React.Fragment, null,
            filters[property] ? (React.createElement(Box_1.Box, { flex: false, pad: { horizontal: 'xsmall' } },
                React.createElement(Text_1.Text, null, filters[property]))) : null,
            React.createElement(Button_1.Button, { icon: React.createElement(SearchIcon, null, "Search"), hoverIndicator: true, onClick: function () { return onFiltering(filtering === property ? undefined : property); } })));
    };
    return Searcher;
}(React.Component));
var SearcherWrapper = recompose_1.compose(styled_components_1.withTheme)(Searcher);
exports.Searcher = SearcherWrapper;
var templateObject_1;
//# sourceMappingURL=Searcher.js.map